<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-layout class="ml-4 mr-4">
			<v-spacer></v-spacer>
			<v-menu offset-y>
				<template v-slot:activator="{ on }">
					<v-btn color="primary" dark v-on="on">
						<v-icon left class="icon-export-offers">save</v-icon>
						Eksport formularzy
					</v-btn>
				</template>

				<v-list>
					<v-list
						v-for="(item, index) in exportMenu"
						:key="index">
						<v-list-tile @click="openModal(item.type)">{{ item.label }}</v-list-tile>
					</v-list>
				</v-list>
			</v-menu>

			<v-btn
				v-if="contestData.status === 'STARTED' && isAdminOrSecretary"
				@click="browseProjects()"
				color="accent">
				<v-icon class="white--text" left>assignment</v-icon>
				Wnioski w zespołach
			</v-btn>
		</v-layout>

		<final-report-form-not-defined-dialog :report-not-defined-dialog="this.reportNotDefinedDialog"
			v-on:close="reportNotDefinedDialog = false"/>

		<v-alert :value="initialized && !placingProjectAllowed" type="warning">
			Konkurs poza terminem naboru wniosków.
		</v-alert>
		<v-alert :value="evaluationDifference" type="warning">
			Rozbieżność ocen we wnioskach: {{warningCodes.join(", ")}}
		</v-alert>

		<v-layout align-center justify-center class="mt-2 mb-2">
			<v-flex xs2>
				<v-text-field
					class="ma-2"
					browser-autocomplete="off"
					label="Numer wniosku"
					aria-label="project code"
					v-model="search.projectCode">
				</v-text-field>
			</v-flex>
			<v-flex xs3>
				<v-text-field
					class="ma-2"
					browser-autocomplete="off"
					label="Oceniający"
					aria-label="evaluator"
					v-model="search.evaluating">
				</v-text-field>
			</v-flex>
			<v-flex xs2>
				<v-autocomplete
					class="ma-2"
					label="Kraj"
					item-text="name"
					item-value="id"
					aria-label="country"
					v-model="search.countryId"
					:items="availableCountries"
					clearable>
				</v-autocomplete>
			</v-flex>
			<v-flex xs3>
				<v-autocomplete
					class="ma-2"
					label="Zespół"
					item-text="name"
					item-value="id"
					aria-label="team"
					v-model="search.teamId"
					:items="availableTeams"
					clearable>
				</v-autocomplete>
			</v-flex>
			<v-flex xs1>
				<v-layout align-center justify-center>
					<v-btn
						color="primary"
						@click="resetSearch">
						Resetuj
					</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>

		<agency-projects-list
			ref="projectList"
			v-if="inclusionStatuses !== null"
			:projects="projects"
			:contest-id="contestData.id"
			:search="search"
			:rejecting-visible="true"
			:expansion-disabled="isProjectWithoutAnyEvaluation"
			:is-expandable="true"
			:is-paginated="true"
			:inclusion-statuses="inclusionStatuses"
			:agency-name-visible="true"
			:show-evaluation-stats="true"
			:warning-codes="warningCodes"
			header="Opiniowanie wniosków"
			empty-warning="W tym naborze nie ma jeszcze wniosków">

			<template v-slot:expandableArea="slotData">
				<agency-contest-evaluation-sublist :project="slotData.project"
					:evaluation-open="contestData.status === 'STARTED'"
					@final-evaluation-removed="finalEvaluationRemoved"
					@substantive-evaluation-removed="substantiveEvaluationRemoved"
					@expert-evaluation-removed="expertEvaluationRemoved"
					@update-warning-codes="prepareWarningCodes"/>
			</template>

			<template v-slot:extraAction="slotData">

				<v-list-tile-action v-if="isAdminOrSecretary">
					<egranty-icon-button
						v-if="slotData.project.agencyProjectStatus === 'REJECTED'"
						icon="block"
						color="primary"
						label="Przywróć wniosek"
						for="agency-all-projects-restore-application"
						id="agency-all-projects-restore-application"
						@click="openRestoreDialog(slotData.project)"
						:disabled="rejectionAndRestoringDisabled(slotData.project)"/>
					<egranty-icon-button
						v-else
						icon="block"
						color="lightred"
						label="Odrzuć wniosek"
						for="agency-all-projects-discard-application"
						id="agency-all-projects-discard-application"
						@click="openRejectDialog(slotData.project)"
						:disabled="rejectionAndRestoringDisabled(slotData.project)"/>
				</v-list-tile-action>

				<v-list-tile-action v-if="isAdminOrSecretary">
					<egranty-icon-button
						v-if="undoRequestAvailable(slotData.project.agencyProjectStatus)"
						for="agency-all-projects-undo-corrections"
						id="agency-all-projects-undo-corrections"
						color="warning"
						icon="cancel"
						label="Cofnij oddanie do poprawek"
						@click="undoRequestChanges(slotData.project)"/>
					<egranty-icon-button
						v-else
						icon="build"
						color="primary"
						label="Oddaj do poprawek"
						for="agency-all-projects-corrections"
						id="agency-all-projects-corrections"
						@click="openCorrectDialog(slotData.project)"
						:disabled="canNotBeSentForCorrections(slotData.project.agencyProjectStatus)"/>
				</v-list-tile-action>

				<assign-agency-projects-for-opinions-menu
					v-if="isAdminOrSecretary"
					:project="slotData.project"
					:contest-id="contestData.id"
					:evaluation-closed="contestData.status !== 'STARTED'"
					:inclusion-statuses="inclusionStatuses"
					@evaluation-assigned="reloadContestProjects"/>

				<v-list-tile-action v-if="isAdminOrSecretary">
					<egranty-icon-button
						icon="star"
						:color="'blue'"
						label="Zatwierdź do realizacji"
						for="agency-all-projects-confirm-application"
						id="agency-all-projects-confirm-application"
						@click="approveProject(slotData.project)"
						:disabled="slotData.project.agencyProjectStatus !== 'SUBMITTED' ||
							!isFinalEvaluationFinished(slotData.project)"/>
				</v-list-tile-action>

				<v-list-tile-action>
					<egranty-icon-button
						icon="compare_arrows"
						color="green lighten-3"
						label="Porównaj wersje"
						:disabled="slotData.project.agencyProjectStatus !== 'AWAITING_CORRECTION'"
						@click="compareProjects(slotData.project.id, slotData.project.agencyProjectData.agencyProjectVersion)"
					/>
				</v-list-tile-action>
			</template>

		</agency-projects-list>

		<egranty-input-field-popup
			:is-open.sync="dialogsState.rejectCause.open"
			label="Powód odrzucenia wniosku"
			for="agency-all-projects-reject-application"
			id="agency-all-projects-reject-application"
			title="Odrzucenie wniosku"
			field-type="LONG_TEXT"
			:long="true"
			@save="rejectSelectedProject">
		</egranty-input-field-popup>

		<v-dialog v-model="correction.dialog" persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">Przekazanie projektu do poprawek</span>
				</v-card-title>
				<v-card-text>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="correctionCause"
						data-vv-as="Powód przekazania do poprawek"
						label="Powód przekazania do poprawek"
						:error-messages="vErrors.collect('correctionCause')"
						v-validate="'required'"
						@keydown="onKeyDownEvent"
						v-model="correction.cause"
						aria-label="correction cause">
					</v-text-field>
					<v-textarea
						browser-autocomplete="off"
						data-vv-name="detailedCorrectionCause"
						data-vv-as="Opis szczegółowy"
						label="Opis szczegółowy"
						v-model="correction.detailedCause"
						:error-messages="vErrors.collect('detailedCorrectionCause')"
						v-validate="'required'"
						aria-label="detailed correction cause">
					</v-textarea>
					<egranty-date-picker
						v-model="correction.correctionDeadline"
						:min="todayString"
						label="Termin na przesłanie poprawek"
						aria-label="correction deadline">
					</egranty-date-picker>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="correction.cause !== '' && correction.detailedCause !== ''"
						color="blue darken-1"
						flat
						@click="requestChanges">
						Wyślij
					</v-btn>
					<v-btn
						color="blue darken-1"
						@click="correction.dialog = false">
						Anuluj
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<agency-project-export-modal ref="agencyProjectExportModal"/>
		<agency-evaluation-export-modal ref="agencyEvaluationExportModal"/>
	</div>
</template>

<script>
	import AgencyProjectsList from "./components/AgencyProjectsList";
	import {Dates} from "@/utils/Dates";
	import {AgencyProject} from "@/api/generated/AgencyProject";
	import {Initializator} from "@/utils/Initializator";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";
	import AgencyContestEvaluationSublist from "../agencyContest/components/AgencyProjectEvaluationSublist";
	import EgrantyInputFieldPopup from "../../../genericComponents/EgrantyInputFieldPopup";
	import AssignAgencyProjectsForOpinionsMenu from "../agencyContest/components/AssignAgencyProjectsForOpinionsMenu";
	import {AgencyContest} from "@/api/generated/AgencyContest";
	import FinalReportFormNotDefinedDialog from "./components/FinalReportFormNotDefinedDialog";
	import {AgencyTaskAccreditationCountry} from "@/api/generated/AgencyTaskAccreditationCountry";
	import {Team} from "@/api/generated/Team";
	import AgencyProjectExportModal from "./components/AgencyProjectExportModal";
	import AgencyEvaluationExportModal from "./components/AgencyEvaluationExportModal";
	import EgrantyDatePicker from "../../../genericComponents/EgrantyDatePicker";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "AllAgencyProjectsListView",

		components: {
			AgencyProjectExportModal,
			AgencyEvaluationExportModal,
			FinalReportFormNotDefinedDialog,
			AssignAgencyProjectsForOpinionsMenu,
			EgrantyInputFieldPopup,
			AgencyContestEvaluationSublist, EgrantyIconButton, AgencyProjectsList,
			EgrantyDatePicker,
		},

		data() {
			return {
				search: {
					countryId: null,
					teamId: null,
					projectCode: "",
					evaluating: "",
				},
				contestData: {
					id: this.$route.params.id,
					status: false,
					finalReportDefined: false,
				},
				dialogsState: {
					rejectCause: {
						open: false,
					},
					selectedProject: null,
				},
				inclusionStatuses: null,
				contestTerms: {},
				ratingSettings: {},
				warningCodes: [],
				projects: null,
				projectsLoaded: false,
				correctionCausesLoaded: false,
				reportNotDefinedDialog: false,
				correction: {
					dialog: false,
					cause: "",
					detailedCause: "",
					correctionDeadline: null,
				},
				correctionCauses: [],
				availableCountries: [],
				availableTeams: [],
				userRole: null,
				exportMenu: [
					{label: "Eksport wniosków", type: "PROJECT_EXPORT"},
					{label: "Eksport ocen", type: "EVALUATION_EXPORT"}
				]
			};
		},

		computed: {
			placingProjectAllowed() {
				return this.isInPast(this.contestTerms.contestStartDateTime)
					&& this.isInFuture(this.contestTerms.contestEndDateTime);
			},

			evaluationDifference() {
				return this.warningCodes.length !== 0;
			},

			todayString() {
				return this.getTodayString();
			},

			isAdminOrSecretary () {
				return this.roles.isAdministrator() || this.roles.isLocalAdministrator() ||
					["SECRETARY", "MAIN_SECRETARY"].includes(this.userRole);
			}
		},

		created() {
			this.reloadContestProjects();
      this.search = this.retrieveFilters(this.search);
		},

		watch: {
			ratingSettings: function () {
				this.prepareWarningCodes();
			},

			"correction.dialog": function (val) {
				if (!val) {
					this.correction.cause = "";
					this.correction.detailedCause = "";
					this.correction.correctionDeadline = null;
				}
			}
		},

		methods: {
			resetSearch() {
				this.search.projectCode = "";
				this.search.evaluating = "";
				this.search.countryId = null;
				this.search.teamId = null;
			},

			compareProjects(projectId, version) {
				let prevVersion = version - 1;
				this.$router.openInNewTab("/view/agency-contest/" + this.contestData.id + "/compare-projects/" + projectId + "/" + prevVersion + "/" + version);
			},

			openEvaluationExportModal() {
        let expertEvaluationsNumber = Math.max(...this.$refs.projectList.projects.map(project => project.expertEvaluations.length));
        this.$refs.agencyEvaluationExportModal.openModal(this.$refs.projectList.notPaginatedProjectsCodes, expertEvaluationsNumber);
			},

			openProjectExportModal() {
				this.$refs.agencyProjectExportModal.openModal(
					{projectCodes: this.$refs.projectList.notPaginatedProjectsCodes},
					this.contestData.id,
					null,
					'SUBMITTED_PROJECTS_LIST');
			},

			openModal(type) {
				switch (type) {
					case "EVALUATION_EXPORT":
						this.openEvaluationExportModal();
						break;
					case "PROJECT_EXPORT":
						this.openProjectExportModal();
						break;
				}
			},

			onKeyDownEvent(evt) {
				if (this.correction.cause.length >= 255 && evt.keyCode >= 48 && evt.keyCode <= 90) evt.preventDefault();
			},

			requestChanges() {
				AgencyProject.putRequestCorrection(this, this.dialogsState.selectedProject.id, this.prepareData(), successResponse => {
					this.correction.dialog = false;
					this.projects
						.filter(o => o.id === this.dialogsState.selectedProject.id)
						.map(o => {
							o.agencyProjectStatus = "AWAITING_CORRECTION";
							o.correctionCause = this.correction.cause;
						o.correctionDeadline = this.correction.correctionDeadline;
					});
				this.$messagesBus.$emit("success", "Pomyślnie oddano wniosek do poprawek", successResponse);
				this.correction.cause = "";
				this.correction.detailedCause = "";
				this.correction.correctionDeadline = null;
			});
		},

			prepareData() {
				return {
					correctionCause: this.correction.cause,
					detailedCorrectionCause: this.correction.detailedCause,
					correctionDeadline: this.correction.correctionDeadline,
				};
			},

			reloadContestProjects() {
				loadUserRole(this);
				loadAvailableCountries(this);
				loadAvailableTeams(this);
				loadContestConfiguration(this);
				loadContestProjects(this);
				loadCorrectionCauses(this);
				loadContestTerms(this);
				loadEvaluationFormsInclusionStatuses(this);
			},

			rejectionAndRestoringDisabled (project) {
				return project.agencyProjectStatus === 'APPROVED' || project.agencyProjectStatus === 'PROJECT_CHANGES_REQUESTED' || project.agencyProjectStatus === 'FINISHED' || (!this.roles.isAdministrator() && !this.roles.isLocalAdministrator() &&
					!['SECRETARY', 'MAIN_SECRETARY'].includes(this.userRole));
			},

			openRestoreDialog (project) {
				this.$confirm("Czy na pewno chcesz przywrócić wniosek?",
					{
						icon: "info",
						color: "primary",
						width: 500,
						title: "Przywrócenie wniosku",
					}).then(response => {
					if (response) {
						AgencyProject.postRestore(this, project.id, successResponse => {
								project.agencyProjectStatus = 'SUBMITTED';
								project.correctionCause = null;
								project.correctionDeadline = null;
								this.$messagesBus.$emit("success", "Wniosek został pomyślnie przywrócony", successResponse);
							},
							errorResponse => {
								this.$messagesBus.$emit("error", "Nie udało się przywrócić wniosku", errorResponse);
							});
					}
				});
			},

      undoRequestChanges(project) {
        this.$confirm("Czy na pewno chcesz wycofać oddanie wniosku do poprawek?", {
          icon: "warning",
          title: "Cofnięcie oddania do poprawek",
          color: "info",
          width: 500,
        })
            .then(response => {
              if (response) {
                AgencyProject.putUndoRequestCorrection(this, project.id, successResponse => {
                      project.agencyProjectStatus = "SUBMITTED";
                      project.correctionCause = null;
                      project.correctionDeadline = null;
                      this.$messagesBus.$emit("success", "Wniosek został pomyślnie wycofany z poprawek", successResponse);
                    },
                    errorResponse => {
                      this.$messagesBus.$emit("error", "Nie udało się wycofać wniosku z poprawek", errorResponse);
                    });
              }
            });
      },

			openRejectDialog(project) {
				this.dialogsState.selectedProject = project;
				this.dialogsState.rejectCause.open = true;
			},

			openCorrectDialog(project) {
				this.dialogsState.selectedProject = project;
				this.correction.dialog = true;
			},

			substantiveEvaluationRemoved(projectId, evaluationIndex) {
				this.projects
					.filter(p => p.id === projectId)
					.map(o => this.$delete(o.substantiveEvaluations, evaluationIndex));
				this.prepareWarningCodes();
			},

			rejectSelectedProject(rejectCause) {
				AgencyProject.postReject(this, this.dialogsState.selectedProject.id, {body: rejectCause},
					successResponse => {
						this.dialogsState.rejectCause.open = false;
						this.projects
							.filter(p => p.id === this.dialogsState.selectedProject.id)
							.map(p => {
								p.agencyProjectStatus = "REJECTED";
								p.rejectCause = rejectCause;
							});
						this.$messagesBus.$emit("success", "Pomyślnie odrzucono wniosek", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się odrzucić wniosku", errorResponse);
					});
				this.dialogsState.rejectCause.open = false;
			},

			approveProject(project) {
				if (!this.contestData.finalReportDefined) {
					this.reportNotDefinedDialog = true;
					return;
				}
				this.$confirm("Zatwierdzenie projektu jest operacją nieodwracalną.", {
					icon: "warning",
					title: "Czy na pewno chcesz zatwierdzić projekt?",
					color: "info",
					width: 600,
				})
					.then(response => {
						if (response) {
							AgencyProject.putApprove(this, project.id, this.reloadContestProjects);
						}
					});
			},

			matchCauses() {
				this.correctionCauses.forEach(item => {
					let project = this.projects.find(p => p.id === item.id);
					this.$set(project, "correctionCause", item.correctionCause);
					this.$set(project, "correctionDeadline", item.correctionDeadline);
				});
			},

			finalEvaluationRemoved(projectId) {
				this.projects.find(el => el.id === projectId).finalEvaluation = null;
				this.prepareWarningCodes();
			},

			expertEvaluationRemoved(projectId, evaluationIndex) {
				this.projects
					.filter(o => o.id === projectId)
					.map(o => this.$delete(o.expertEvaluations, evaluationIndex));
				this.prepareWarningCodes();
			},

      undoRequestAvailable(status) {
        return status === "AWAITING_CORRECTION";
      },

			canNotBeSentForCorrections(status) {
				return status === "REJECTED"
					|| status === "AWAITING_CORRECTION"
					|| status === "PROJECT_CHANGES_REQUESTED";
			},

			prepareWarningCodes() {
				this.warningCodes = [];
				if (!this.ratingSettings.booleanEvaluation) return;

				let twoFinishedEvaluationProject = this.projects.filter(p =>
					p.substantiveEvaluations.length === 2 &&
					p.substantiveEvaluations.filter(e => e.agencySubstantiveEvaluationStatus === "FINISHED").length === 2,
				);

				twoFinishedEvaluationProject.forEach(project => {
					let subEvaluations = project.substantiveEvaluations;
					if (subEvaluations[0].recommending !== subEvaluations[1].recommending) this.warningCodes.push(project.agencyProjectCode);
				});
			},

			isProjectWithoutAnyEvaluation(project) {
				return project.substantiveEvaluations.length === 0
					&& project.finalEvaluation === null
					&& project.expertEvaluations.length === 0;
			},

			browseProjects() {
				this.$router.push("/app/agency-contest/" + this.contestData.id + "/manage-teams");
			},

			isFinalEvaluationFinished(project) {
				if (project.finalEvaluation === null || project.finalEvaluation.agencyFinalEvaluationStatus === null) {
					return false;
				}
				return project.finalEvaluation.agencyFinalEvaluationStatus === "FINISHED";
			},
		},

		mixins: [
			Dates,
			Initializator,
      Filters
		],
	};

	function loadContestConfiguration(ctx) {
		AgencyContest.getContestConfiguration(ctx, ctx.contestData.id,
			successResponse => {
				ctx.contestData.finalReportDefined = successResponse.finalReportDefined;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować konfiguracji naboru", errorResponse);
			});
	}

	function loadContestProjects(ctx) {
		AgencyProject.getSubmittedProjectList(ctx, ctx.contestData.id,
			successResponse => {
				ctx.projects = successResponse;
				getContestRatingSettings(ctx);
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować wniosków", errorResponse);
			});
	}

	function loadCorrectionCauses(ctx) {
		AgencyProject.getSubmittedProjectsCorrectionCauses(ctx, ctx.contestData.id,
			successResponse => {
				ctx.correctionCauses = successResponse;
				ctx.correctionCausesLoaded = true;
				if (ctx.projectsLoaded && ctx.correctionCausesLoaded) ctx.matchCauses();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować powodów do poprawek", errorResponse);
			});
	}

	function loadContestTerms(ctx) {
		AgencyContest.getContestTerms(ctx, ctx.contestData.id,
			successResponse => {
				ctx.contestTerms = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować warunków konkursu", errorResponse);
			});
	}

	function loadEvaluationFormsInclusionStatuses(ctx) {
		AgencyContest.getEvaluationFormsInclusionStatus(ctx, ctx.contestData.id,
			successResponse => {
				ctx.inclusionStatuses = successResponse.agencyContestSchemaSet;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować danych o formularzach ocen", errorResponse);
			});
	}

	function getContestRatingSettings(ctx) {
		AgencyContest.getRatingSettings(ctx, ctx.contestData.id, successResponse => {
				ctx.ratingSettings = successResponse.ratingSettings;
				ctx.contestData.status = successResponse.agencyContestStatus;
				ctx.projectsLoaded = true;
				if (ctx.correctionCausesLoaded) ctx.matchCauses();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować parametrów ocen", errorResponse);
			});
	}

	function loadUserRole (ctx) {
		AgencyContest.getUserRole(ctx, ctx.contestData.id, successResponse => {
				ctx.userRole = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować roli użytkownika", errorResponse);
			});
	}

	function loadAvailableCountries(ctx) {
		AgencyTaskAccreditationCountry.getAvailableCountries(ctx, ctx.contestData.id, successResponse => {
				ctx.availableCountries = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować dostępnych krajów", errorResponse);
			});
	}

	function loadAvailableTeams(ctx) {
		Team.getTeams(ctx, ctx.contestData.id, successResponse => {
			ctx.availableTeams = successResponse;
			ctx.availableTeams.push({id: -1, name: "Nieprzydzielone"});
		});
	}

</script>

<style scoped>
	.theme--dark .amber {
		background-color: #072be1 !important;
	}

	.theme--dark .v-alert .v-alert__icon.v-icon, .v-alert__dismissible .v-icon {
		color: #fff;
	}
</style>
